import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import store from "./store";
import "./assets/css/global.css";
import "./assets/styles/main.scss"; // 引入全局样式文件
import i18n from "./i18n";
import * as request from "./utils/http";

Vue.prototype.$http = request; // 将request挂载到Vue的原型上，这样就可以在所有组件中通过this.$http来访问了。
// 捕获导航错误
router.onError((error) => {
  if (error.message.includes('Cancelled')) {
    return
  }
})
// 在 main.js 中注册全局指令
Vue.directive('error-img', {
  inserted(el, binding) {
    el.onerror = () => {
      el.src = binding.value; // 使用指令值作为占位图
      el.onerror = null; // 防止死循环
    };
  }
});

Vue.use(ElementUI);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
